let _id = 1000;

export const uid = () => ++_id;

export const now = () => new Date().toISOString().slice(0, 10);

export const deepClone = (obj) =>
  typeof structuredClone === "function"
    ? structuredClone(obj)
    : JSON.parse(JSON.stringify(obj));

export const findNode = (nodes, id) => {
  for (const node of nodes) {
    if (node.id === id) return node;
    if (node.children) {
      const result = findNode(node.children, id);
      if (result) return result;
    }
  }
  return null;
};

export const allDescIds = (node) => {
  let ids = [node.id];
  (node.children || []).forEach((child) => {
    ids = ids.concat(allDescIds(child));
  });
  return ids;
};

export const getChain = (nodes, id, chain = []) => {
  for (const node of nodes) {
    if (node.id === id) return [...chain, node];
    if (node.children) {
      const result = getChain(node.children, id, [...chain, node]);
      if (result) return result;
    }
  }
  return null;
};

export const makeService = ({ id, name, locId, available, availType, autoProv, sso, assignable }) =>
  ({ id, name, locationId: locId, available, availType, autoProv, sso, assignable });

export const makeResource = (id, name, program, locId, active, autoAssign, hidden) =>
  ({
    id,
    name,
    program,
    locationId: locId,
    active,
    recordStatus: true,
    autoAssign,
    hidden,
  });
